<template>
	<v-card class="elevation-3" color="white">
		<v-card-title class="secondary--text">
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="closeOfferSet()">mdi-close</v-icon>
		</v-card-title>
		<v-row no-gutters>
			<v-col>
				<div align="center" justify="center">
					<v-avatar color="white" size="100">
						<img class="white--text align-end" height="30" :src="require('@/assets/icons/✅.svg')" />
						<!--img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" --/ -->
					</v-avatar>
				</div>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<h3 color="primary--text" class="title font-weight-bold" align="center" justify="center">Public Offer Posted</h3>
			</v-col>
		</v-row>

		<!-- <v-row no-gutters>
			<v-col>
				<p align="center" class="subtitle primary--text font-weight-bold" justify="center">Find Locums</p>
			</v-col>
		</v-row> -->
	</v-card>
</template>

<script>
// import { bus } from "@/main";
export default {
	name: 'PracticeOfferSet',
	components: {},
	data: () => ({}),
	methods: {
		created() {
			//check if authenticated ?
		},

		closeOfferSet() {
			this.$emit('dismiss', this);
		},
	},
};
</script>
